import * as actionType from "../constants/actionTypes";

const initialState = {
  tables: [],
  loading: false,
  error: null,
  message: "",
};

const listOfTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_LIST_OF_TABLES:
      return {
        ...state,
        tables: action.payload?.tables || [],
        loading: false,
        error: action.payload?.error || null,
        message: action.payload?.error ? "Failed to fetch tables" : "Fetched successfully",
      };

    default:
      return state;
  }
};


export default listOfTablesReducer;
